import {Inject, Injectable} from '@angular/core';
import {UserRequestVerification} from '../model/request/user-request-verification-action.model';
import {CplUserRequest} from '../model/cpl-user-request.model';
import {VerificationHistory} from '../model/cpl-verification-history.model';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VerifyRequestApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    verify(UserVerification: UserRequestVerification) {
        return this.http.post(this.baseUri + '/verifyRequest', UserVerification, { responseType: 'text' });
    }
    bulkVerify(UserVerification: UserRequestVerification[]) {
        return this.http.post(this.baseUri + '/verifyRequest/bulk', UserVerification);
    }
    reassign(userRequest: CplUserRequest) {
        return this.http.post(this.baseUri + '/verifyRequest/reassign', userRequest, { responseType: 'text' });
    }
    submitForVerification(userRequest: CplUserRequest) {
        return this.http.post(this.baseUri + '/verifyRequest/submitRequest', userRequest, { responseType: 'text' });
    }
    submitFollowup(userRequest: CplUserRequest) {
        return this.http.post(this.baseUri + '/verifyRequest/submitFollowup', userRequest, { responseType: 'text' });
    }
    // End Users can Cancel and Restore Requests
    // For now, they can only submit one request at a time
    userVerification(UserVerification: UserRequestVerification) {
        return this.http.post(this.baseUri + '/verifyRequest/userVerification', UserVerification, { responseType: 'text' });
    }
    getVerifyHistoryByUserCycleId(userRequestId: string) {
        return this.http.get<VerificationHistory[]>(this.baseUri + '/verifyRequest/history/' + userRequestId);
    }
}